import { Fragment } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { JustifyContentTitle } from "../../../Constants/Constants";
import { JustifyContentSubTitle, JustifyData } from "../../../Data/UiKits/Dropdown";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import DropdownCommon from "./Common/DropdownCommon";

const JustifyContent = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={JustifyContentTitle} span={JustifyContentSubTitle} />
        <CardBody className="dropdown-basic m-0">
          <div className="common-flex">
            {JustifyData &&
              JustifyData.map((item, index) => (
                <Fragment key={index}>
                  <DropdownCommon item={item} />
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default JustifyContent;
